import type { RoleModel } from '../models.ts'

export const OrganizationAdminRole: RoleModel = {
  name: 'Organization Admin',
  key: 'organization-admin',
  privileges: ['core', 'organization-admin'],
  organizationTypes: ['brand', 'agency', 'internal'],
}

// Note: Brand, Agency, and Internal roles are legacy placeholders used to maintain parity with the previous access-control model.
// Going forward, these will be replaced with more descriptive, persona-driven roles, breaking them into finer-grained roles.

export const BrandRole: RoleModel = {
  name: 'Brand',
  key: 'brand',
  privileges: ['core', 'brand'],
  organizationTypes: ['brand'],
}

export const AgencyRole: RoleModel = {
  name: 'Agency',
  key: 'agency',
  privileges: ['core', 'agency'],
  organizationTypes: ['agency'],
}

export const InternalRole: RoleModel = {
  name: 'Internal',
  key: 'internal',
  privileges: ['core', 'organization-admin', 'internal'],
  organizationTypes: ['internal'],
}

export const SystemRole: RoleModel = {
  name: 'System',
  key: 'system',
  privileges: ['all'],
  organizationTypes: [],
}

export const AllRoles = [
  BrandRole,
  OrganizationAdminRole,
  AgencyRole,
  InternalRole,
  SystemRole,
]
